import React from "react";
import { PrimaryText } from "../../styles/global";
import { FieldContainer, InputField, TextArea } from "./style";
import { useForm, ValidationError } from "@formspree/react";


const ContactForm = () => {
  const [state, handleSubmit] = useForm("mvonrorn");
 
  if (state.succeeded) {
    return (
      <div className="flex justify-center items-center h-[40vh] border card-shadow rounded-2xl p-6 md:p-8 ">
        <PrimaryText>
          Thank you for getting in touch!! I'll get back to you soon.. 😄{" "}
        </PrimaryText>
      </div>
    );
  }


  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="border card-shadow rounded-2xl p-6 md:p-8"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 ">
          <div id="section-1" className="">
            <FieldContainer>
              <PrimaryText>Name: <span className="text-red-500">*</span></PrimaryText>
              <InputField
                id="name"
                type="text"
                name="name"
                placeholder="🪪 Enter your name"
                required
              />
            </FieldContainer>
            <FieldContainer>
              <PrimaryText>Email Address: <span className="text-red-500 ">*</span></PrimaryText>
              <InputField
                id="email"
                type="email"
                name="email"
                placeholder="📨 Enter your email"
                required
              />
              <ValidationError field="email" prefix="Email" errors={state.errors} />
            </FieldContainer>

            <FieldContainer>
              <PrimaryText>Contact:</PrimaryText>
              <InputField
                id="contact"
                type="number"
                name="contact"
                placeholder="📱Enter your Contact No."
              />
            </FieldContainer>
          </div>
          <div id="section-2" className=" flex justify-start  md:px-12">
            <FieldContainer>
              <PrimaryText>Message: <span className="text-red-500">*</span></PrimaryText>
              <TextArea
                id="message"
                name="message"
                cols="35"
                rows="11"
                placeholder="👋 Write a message..."
                required
              />
            </FieldContainer>

          </div>
        </div>

        <div className="flex justify-center items-center  mt-10">
          <button
            className="primary-btn"
            type="submit"
            disabled={state.submitting}
          >
            Submit
          </button>
       
        </div>
      </form>
    </>
  );
};

export default ContactForm;
